var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoweroffice = function SvgPoweroffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#poweroffice_csvg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__b)",
    d: "M26.365 0h-8.412l-4.27 7.376h8.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__c)",
    d: "m26.365 0-4.27 7.376 4.27 7.377 4.27-7.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE3F6D",
    d: "m13.682 7.376 4.27 7.377h8.413l-4.27-7.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1663B",
    d: "m17.953 29.377-4.27 7.376h8.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F05930",
    d: "M26.365 29.377h-8.412l4.27 7.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__d)",
    d: "M30.635 36.623h-8.412L26.495 44l4.141-7.377Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__e)",
    d: "m26.365 29.377-4.27 7.376h8.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__f)",
    d: "M22.094 36.623h-8.412L17.952 44h8.413l-4.27-7.377Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__g)",
    d: "M5.27 22 1 29.377h8.412L13.682 22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__h)",
    d: "m13.682 22-4.27 7.377 4.27 7.376 4.27-7.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F16B41",
    d: "m1 29.377 4.27 7.376h8.412l-4.27-7.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__i)",
    d: "M13.682 7.376H5.271L1 14.753h8.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__j)",
    d: "m13.682 7.376-4.27 7.377L13.682 22l4.27-7.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE3F6D",
    d: "M1 14.623 5.27 22h8.412l-4.27-7.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__k)",
    d: "m30.506 22 4.27 7.377L39.047 22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F16238",
    d: "m30.506 22-4.27 7.377h8.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__l)",
    d: "m34.776 29.377-4.27 7.376h8.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__m)",
    d: "m39.047 22-4.27 7.377 4.27 7.376 4.27-7.377L39.048 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F68C33",
    d: "m26.365 29.377 4.27 7.376 4.27-7.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__n)",
    d: "m30.506 7.376-4.27 7.377h8.411l4.27-7.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#poweroffice_csvg__o)",
    d: "m39.047 7.376-4.27 7.377 4.27 7.376 4.27-7.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F05B40",
    d: "M34.776 14.623h-8.411L30.635 22h8.412z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__b",
    x1: -341.004,
    x2: -340.305,
    y1: 3.676,
    y2: 3.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE402F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__c",
    x1: 22.964,
    x2: 33.864,
    y1: 13.201,
    y2: 6.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B0233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__d",
    x1: 24.347,
    x2: 27.357,
    y1: 40.136,
    y2: 33.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#F79D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#F9AE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#FAB771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBB76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__e",
    x1: 26.345,
    x2: 26.345,
    y1: 35.868,
    y2: 30.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#F27138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#F37C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__f",
    x1: 13.664,
    x2: 26.371,
    y1: 40.324,
    y2: 40.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBB76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__g",
    x1: 14.914,
    x2: -0.102,
    y1: 25.668,
    y2: 25.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4D6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__h",
    x1: 11.368,
    x2: 19.664,
    y1: 33.349,
    y2: 28.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2744A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__i",
    x1: -340.677,
    x2: -339.978,
    y1: 11.001,
    y2: 11.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE402F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__j",
    x1: 10.055,
    x2: 21.921,
    y1: 20.959,
    y2: 14.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B0233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__k",
    x1: 34.772,
    x2: 34.772,
    y1: 21.971,
    y2: 24.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE402F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05B40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__l",
    x1: 30.538,
    x2: 39.008,
    y1: 33.007,
    y2: 33.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBB76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__m",
    x1: 35.826,
    x2: 45.355,
    y1: 34.839,
    y2: 29.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__n",
    x1: 25.478,
    x2: 41.754,
    y1: 11.009,
    y2: 11.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poweroffice_csvg__o",
    x1: 36.862,
    x2: 42.655,
    y1: 18.371,
    y2: 15.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B00D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4E28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "poweroffice_csvg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgPoweroffice;